import React from 'react';
import {useParams} from 'react-router-dom';
import FormModal from "components/modals/FormModal";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {useCreateLocationMutation, useGetLocationQuery, useUpdateLocationMutation} from "../../apis/locationApi";
import states from "../../data/states.json";
import {useUserProfileQuery} from "../../apis/authenticationApi";

const LocationModal = () => {
    const { location } = useParams();
    const {data: editLocation, isFetching} = useGetLocationQuery(location);
    const [createLocation] = useCreateLocationMutation();
    const [updateLocation] = useUpdateLocationMutation();
    const {data: userProfile} = useUserProfileQuery();
    const editOnly = userProfile?.company?.role !== "CompanyOwner";

    const handleSubmit = (data) => {
        if(!data.id || data.id === 'new') {
            createLocation(data);
        }
        else {
            updateLocation(data)
        }
    }

    if(isFetching) {
        return (<></>);
    }
    else {
        return (<FormModal type="Location" editObject={editLocation || {name: ''}} handleSubmit={!editOnly? handleSubmit : undefined}
               renderForm={(formik) =>
                   (<form onSubmit={formik.handleSubmit} className="formgrid grid">
                       <div className="field col-12">
                            <span className="p-float-label">
                                <InputText id="name" name="name" className="inputfield w-full" value={formik.values?.name} onChange={formik.handleChange} autoFocus disabled={editOnly}/>
                                <label htmlFor="name">Name</label>
                            </span>
                       </div>
                       <div className="field col-12">
                            <span className="p-float-label">
                                <InputText id="address1" name="address1" className="inputfield w-full" value={formik.values?.address1} onChange={formik.handleChange} disabled={editOnly}/>
                                <label htmlFor="address1">Address 1</label>
                            </span>
                       </div>
                       <div className="field col-12">
                            <span className="p-float-label">
                                <InputText id="address2" name="address2" className="inputfield w-full" value={formik.values?.address2} onChange={formik.handleChange} disabled={editOnly}/>
                                <label htmlFor="address2">Address 2</label>
                            </span>
                       </div>
                       <div className="field col-12 city-state-zip flex">
                            <span className="p-float-label city-input">
                                <InputText id="city" name="city" className="inputfield w-full" value={formik.values?.city} onChange={formik.handleChange} disabled={editOnly}/>
                                <label htmlFor="city">City</label>
                            </span>
                           <span className="p-float-label state-input">
                                <Dropdown name="state" value={formik.values?.state} options={states} onChange={formik.handleChange} optionLabel="name" optionValue="code" placeholder="Select a State"disabled={editOnly}/>
                           </span>
                           <span className="p-float-label zipcode-input">
                                <InputText id="zipCode" name="zipCode" className="inputfield w-full" value={formik.values?.zipCode} onChange={formik.handleChange} disabled={editOnly}/>
                                <label htmlFor="zipCode">Zip Code</label>
                           </span>
                       </div>
                   </form>)
               }>
        </FormModal>)
    }
}

export default LocationModal;